/**
 * Inhalt der Verlaufskarte je Zustand: lädt, ohne Objektliste, keine Verbindung, Ladefehler mit
 * Grund, leer oder die Liste. Scheitert nur ein Nachladen, bleiben die Zeilen mit Hinweis stehen.
 */
import type { ReactNode } from 'react';
import { SurfaceLoadError, SurfaceLoading, SurfaceStaleHint } from '@/shared/components';

interface Props {
  loading: boolean;
  /** Ein Grund, warum es noch nichts zu zeigen gibt (Objektliste, Verbindung, Ladefehler). */
  problem: string | null;
  stale: boolean;
  empty: boolean;
  retrying: boolean;
  onRetry: () => void;
  children: ReactNode;
}

export function HistoryContent(props: Props) {
  return (
    <>
      {props.stale && <SurfaceStaleHint onRetry={props.onRetry} retrying={props.retrying} />}
      {props.loading ? (
        <SurfaceLoading label="Verlauf wird geladen" rows={6} />
      ) : props.problem ? (
        <SurfaceLoadError
          message={props.problem}
          onRetry={props.onRetry}
          retrying={props.retrying}
        />
      ) : props.empty ? (
        <div className="flex flex-col items-center gap-1.5 px-5 py-12 text-center">
          <b className="text-base">Keine Einträge in diesem Filter</b>
          <span className="text-ink-soft text-[13px]">
            Zeitraum erweitern oder Filter zurücksetzen.
          </span>
        </div>
      ) : (
        props.children
      )}
    </>
  );
}
